import React from 'react';
import { AtSign } from 'lucide-react';
import { useStore } from '../store';

export default function XButton() {
  const isModelAnimationComplete = useStore((state) => state.isModelAnimationComplete);

  const handleBookingClick = () => {
    window.open('https://x.com/iratefitpics', '_blank');
  };

  return (
    <>
      {isModelAnimationComplete && (
        <button
          onClick={handleBookingClick}
          className="relative group bg-[#9181B7] text-white px-8 py-2.5 rounded-lg 
            hover:bg-[#313337] transition-all duration-300 min-w-[250px]
            flex items-center justify-center gap-2 shadow-lg hover:shadow-xl
            opacity-0 animate-fade-in"
        >
          <AtSign className="w-5 h-5" />
          iratefitpics
        </button>
      )}
    </>
  );
}

